const Assortment = 'Assortment';

export default Assortment;
